import axios from "axios";
import { ApiUrl } from "../../api";

export const updateCookie = () => {
  return axios
    .get(ApiUrl.Cookie.MarkHelpNotificationRead)
    .then(({ data }) => data);
};
